import * as React from "react";
import ReactHtmlParser from 'react-html-parser';

export interface TipProps {
  formFieldDefinition: any; 
}

export const Tip = (props: TipProps) => {

    let icon = props.formFieldDefinition.tipIcon || "idea";
    let label = "<p>" + props.formFieldDefinition.label + "</p>";
    let layout = (props.formFieldDefinition.tipLayout || "").toLowerCase();

    if (props.formFieldDefinition.tip !== undefined && props.formFieldDefinition.tip !== "") {
        label = props.formFieldDefinition.tip;
    }

    let labelHtml = ReactHtmlParser(label);
    if (layout == "" || layout == "callout") {        
        return <div className="container form-tip-block">            
            <div className="row content__callout content__callout-yellow">
                <div className="col-auto content__callout-icon-container content__callout-tip">
                    <span className={"icon icon-" + icon}></span>
                </div>
                <div className="col content__callout-content">
                    {labelHtml}
                </div>
            </div>
        </div>;
    } else if (layout == "block") {      
        return <div className="container content__callout-blue">            
            <div className="row content__callout"> 
                <div className="col content__callout-content d-flex">
                    <span className={"icon icon-" + icon + " mr-2 color-primary"}></span>
                    <div className="flex-grow-1 flex-shrink-1">{labelHtml}</div>
                </div>
            </div>
        </div>;
    } else {
        return <div className="fnv-form__container-form widget mijn-fnv-form__tip-block">
            <div className="mijn-fnv__warning">
                <span className={"icon icon-" + icon}></span>
                {labelHtml}
            </div>
        </div>;
    }
};